import React, {PropTypes as T} from 'react';

const InfoIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Info Icon"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__info ${className}`}>
    <path d="M268.18 348.43l34.742-158.743h-24.61l-63.187 2.391-3.242 14.258c8.492.828 14.062 2.39 16.719
      4.781 2.64 2.39 4.007 6.375 4.007 12.008 0 3.32-.367 7.328-1.078 12.188-.71 4.804-2.031 11.523-3.906 20.14L193.985
      406h89.718l2.367-14.258c-7.882-.828-13.43-2.64-16.695-5.375-3.25-2.734-4.86-7.18-4.86-13.351
      0-2.32.196-5.204.61-8.641.492-3.445 1.469-8.766 3.055-15.945zm-17.235-189.57h55.813L318.016 106h-55.227l-11.844
      52.86zM256 6C117.914 6 6 117.914 6 256s111.914 250 250 250 250-111.914 250-250S394.086 6 256 6zm0 475C131.93 481
      31 380.07 31 256S131.93 31 256 31s225 100.93 225 225-100.93 225-225 225z" />
  </svg>
);

InfoIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  InfoIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_info.js